import { IUseFetchOptionsParams } from '@common/api.models';
import { FETCH_QUERIES_NAME } from '@common/constants';
import { createUseFetchOptionsNoPropsFn } from '@common/selectOptions.services';
import { getAllRiskCategoriesAsync } from './riskCategory.services';

export const useFetchAllRiskCategories = ({ isDirty = false, shouldConvertOptions = false }: IUseFetchOptionsParams) =>
  createUseFetchOptionsNoPropsFn({
    queryName: FETCH_QUERIES_NAME.RISK_CATEGORIES,
    getOptionsFn: getAllRiskCategoriesAsync,
    handleOptionsProps: {
      shouldConvertOptions,
      textFieldName: 'category',
    },
    enabled: !isDirty,
  });

export const useFetchAllPermittedRiskCategories = ({
  isDirty = false,
  shouldConvertOptions = true,
}: IUseFetchOptionsParams) =>
  createUseFetchOptionsNoPropsFn({
    queryName: FETCH_QUERIES_NAME.PERMITTED_RISK_CATEGORIES,
    getOptionsFn: getAllRiskCategoriesAsync,
    handleOptionsProps: {
      shouldConvertOptions,
      textFieldName: 'permittedName',
    },
    enabled: !isDirty,
  });
